import { client } from "@/stores/client.js";
import { getAuthenticatedRequest as getLiveAuthenticatedRequest } from "@/stores/AuthenticatedRequest.js";

export function getAuthenticatedRequest(subRequest, payload = {}) {
  return {
    ...getLiveAuthenticatedRequest(),
    subRequest,
    ...payload,
  };
}

export function getPublicRequest(request, payload = {}) {
  return {
    request,
    client,
    ...payload,
  };
}
